export enum InboxMethod {
    Set = 'set',
    Inbox = 'inbox',
}

export enum InboxAction {
    Messages = 'message.list',
    Count = 'message.count',
    UserId = 'user_id',
    SetAction = 'message.actions',
}
